// extracted by mini-css-extract-plugin
export default {"columns":"risk_columns__amWlV","description":"risk_description__sWVQ6","status":"risk_status__5etvZ","statsInfo":"risk_statsInfo__RBLuz"};